<template>
  <div class="mdb-month-view">
    <h2 class="d-md-none d-sm-block text-left ml-2"><strong>{{monthNames[date.getMonth()]}} {{date.getFullYear()}}</strong></h2>
    <div class="d-flex justify-content-between mb-3">
      <mdb-btn-group size="sm">
        <mdb-btn size="sm" outline="info" icon="chevron-left" darkWaves @click.native="changeMonth('prev')"></mdb-btn>
        <mdb-btn size="sm" outline="info" icon="chevron-right" darkWaves @click.native="changeMonth('next')"></mdb-btn>
        <mdb-btn class="px-3" outline="info" darkWaves @click.native="changeMonth('today')">{{todayText}}</mdb-btn>
      </mdb-btn-group>
      <h2 class="d-none d-md-block"><strong>{{monthNames[date.getMonth()]}} {{date.getFullYear()}}</strong></h2>
    </div>
    <table>
      <thead>
        <tr>
          <th v-for="(weekDay, index) in dayNames" :key="index">{{weekDay}}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td v-for="(day, index) in monthData.slice(0,7)" :key="index" :class="{'light-blue lighten-5': day.today === true, 'rgba-mdb-color-slight': day.date.getDay() === 0 || day.date.getDay() === 6}">
            <div :class="[{'text-light': day.type === 'light'}, 'mdb-day-field']">{{day.day}}</div>
            <div v-for="(event, eventIndex) in events" :key="eventIndex">
              <div class="d-none d-md-block" v-if="event.start <= new Date(day.date.getFullYear(), day.date.getMonth(), day.date.getDate(), 23, 59, 59) && event.end >= day.date" :class="eventClass(event, day)">{{event.title}}</div>
                <div class="d-md-none d-sm-block" v-if="event.start <= new Date(day.date.getFullYear(), day.date.getMonth(), day.date.getDate(), 23, 59, 59) && event.end >= day.date" :class="eventClass(event, day)">{{event.title | shorten}}</div>
            </div>
          </td>
        </tr>
        <tr>
          <td v-for="(day, index) in monthData.slice(7,14)" :key="index" :class="{'light-blue lighten-5': day.today === true, 'rgba-mdb-color-slight': day.date.getDay() === 0 || day.date.getDay() === 6}">
            <div :class="[{'text-light': day.type === 'light'}, 'mdb-day-field']">{{day.day}}</div>
            <div v-for="(event, eventIndex) in events" :key="eventIndex">
              <div @click.stop="showEventInfo(eventIndex)">
                <div class="d-none d-md-block" v-if="event.start <= new Date(day.date.getFullYear(), day.date.getMonth(), day.date.getDate(), 23, 59, 59) && event.end >= day.date" :class="eventClass(event, day)">{{event.title}}</div>
                <div class="d-md-none d-sm-block" v-if="event.start <= new Date(day.date.getFullYear(), day.date.getMonth(), day.date.getDate(), 23, 59, 59) && event.end >= day.date" :class="eventClass(event, day)">{{event.title | shorten}}</div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td v-for="(day, index) in monthData.slice(14,21)" :key="index" :class="{'light-blue lighten-5': day.today === true, 'rgba-mdb-color-slight': day.date.getDay() === 0 || day.date.getDay() === 6}" >
            <div :class="[{'text-light': day.type === 'light'}, 'mdb-day-field']">{{day.day}}</div>
            <div v-for="(event, eventIndex) in events" :key="eventIndex">
              <div @click.stop="showEventInfo(eventIndex)">
                <div class="d-none d-md-block" v-if="event.start <= new Date(day.date.getFullYear(), day.date.getMonth(), day.date.getDate(), 23, 59, 59) && event.end >= day.date" :class="eventClass(event, day)">{{event.title}}</div>
                <div class="d-md-none d-sm-block" v-if="event.start <= new Date(day.date.getFullYear(), day.date.getMonth(), day.date.getDate(), 23, 59, 59) && event.end >= day.date" :class="eventClass(event, day)">{{event.title | shorten}}</div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td v-for="(day, index) in monthData.slice(21,28)" :key="index" :class="{'light-blue lighten-5': day.today === true, 'rgba-mdb-color-slight': day.date.getDay() === 0 || day.date.getDay() === 6}">
            <div :class="[{'text-light': day.type === 'light'}, 'mdb-day-field']">{{day.day}}</div>
            <div v-for="(event, eventIndex) in events" :key="eventIndex">
              <div @click.stop="showEventInfo(eventIndex)">
                <div class="d-none d-md-block" v-if="event.start <= new Date(day.date.getFullYear(), day.date.getMonth(), day.date.getDate(), 23, 59, 59) && event.end >= day.date" :class="eventClass(event, day)">{{event.title}}</div>
                <div class="d-md-none d-sm-block" v-if="event.start <= new Date(day.date.getFullYear(), day.date.getMonth(), day.date.getDate(), 23, 59, 59) && event.end >= day.date" :class="eventClass(event, day)">{{event.title | shorten}}</div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td v-for="(day, index) in monthData.slice(28,35)" :key="index" :class="{'light-blue lighten-5': day.today === true, 'rgba-mdb-color-slight': day.date.getDay() === 0 || day.date.getDay() === 6}">
            <div :class="[{'text-light': day.type === 'light'}, 'mdb-day-field']">{{day.day}}</div>
            <div v-for="(event, eventIndex) in events" :key="eventIndex">
              <div @click.stop="showEventInfo(eventIndex)">
                <div class="d-none d-md-block" v-if="event.start <= new Date(day.date.getFullYear(), day.date.getMonth(), day.date.getDate(), 23, 59, 59) && event.end >= day.date" :class="eventClass(event, day)">{{event.title}}</div>
                <div class="d-md-none d-sm-block" v-if="event.start <= new Date(day.date.getFullYear(), day.date.getMonth(), day.date.getDate(), 23, 59, 59) && event.end >= day.date" :class="eventClass(event, day)">{{event.title | shorten}}</div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td v-for="(day, index) in monthData.slice(35,42)" :key="index" :class="{'light-blue lighten-5': day.today === true, 'rgba-mdb-color-slight': day.date.getDay() === 0 || day.date.getDay() === 6}">
            <div :class="[{'text-light': day.type === 'light'}, 'mdb-day-field']">{{day.day}}</div>
            <div v-for="(event, eventIndex) in events" :key="eventIndex">
              <div @click.stop="showEventInfo(eventIndex)">
                <div class="d-none d-md-block" v-if="event.start <= new Date(day.date.getFullYear(), day.date.getMonth(), day.date.getDate(), 23, 59, 59) && event.end >= day.date" :class="eventClass(event, day)">{{event.title}}</div>
                <div class="d-md-none d-sm-block" v-if="event.start <= new Date(day.date.getFullYear(), day.date.getMonth(), day.date.getDate(), 23, 59, 59) && event.end >= day.date" :class="eventClass(event, day)">{{event.title | shorten}}</div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>            
    </table>
  </div>
</template>

<script>
import { mdbBtn, mdbBtnGroup } from 'mdbvue'

const mdbMonthView =  {
  name: 'mdbMonthView',
  components: {
    mdbBtn,
    mdbBtnGroup,
  },
  props: {
    defaultDate: {
      type: Date
    },
    dayNames: {
      type: Array
    },
    monthNames: {
      type: Array
    },
    todayText: {
      type: String
    },
    events: {
      type: [Array, Boolean]
    }
  },
  data() {
    return {
      monthData: [],
    };
  },
  created() {
    this.date = this.defaultDate
    this.buildMonthData()
  },
  methods: {
    getDaysInMonth(month, year) {
      let date = new Date(year, month, 1)
      let days = []
      while (date.getMonth() === month) {
        days.push(new Date(date).getDate());
        date.setDate(date.getDate() + 1)
      }
      return days;
    },
    buildMonthData() {
      let newData = []
      let firstDayOfMonth = new Date(this.date.getFullYear(), this.date.getMonth(), 1).getDay()
      let daysInMonth = this.getDaysInMonth(this.date.getMonth(), this.date.getYear())
      let prevMonth = this.date.getMonth() === 0 ? 11 : this.date.getMonth() - 1
      let prevYear = prevMonth === 12 ? this.date.getYear() - 1 : this.date.getYear()
      let daysInPrevMonth = this.getDaysInMonth(prevMonth, prevYear)
      let lastDayOfPrevMonth = daysInPrevMonth.pop()
      let i = 0, j = 0
      for (i; i < 42; i++) {
        if (i >= firstDayOfMonth) {
          if (daysInMonth[i - firstDayOfMonth] === undefined) {
            j++
            newData.push({
              day: j,
              date: new Date(this.date.getFullYear(), this.date.getMonth() + 1, j),
              type: 'light'
            })
          } else {
            let currentDate = new Date(this.date.getFullYear(), this.date.getMonth(), i - firstDayOfMonth + 1)
            let checkToday = currentDate.toDateString() === new Date().toDateString() ? true : false
            newData.push({
              day: daysInMonth[i - firstDayOfMonth],
              date: currentDate,
              today: checkToday
            })
          }
        } else {
          newData.push({
            day: lastDayOfPrevMonth - firstDayOfMonth + i + 1,
            date: new Date(this.date.getFullYear(), this.date.getMonth() - 1, lastDayOfPrevMonth - firstDayOfMonth + i + 1),
            type: 'light'
          })
        } 
      }
      this.monthData = newData;
    },
    changeMonth(target) {
      if (target === 'prev') {
        this.date = new Date(this.date.getFullYear(), this.date.getMonth() - 1)
        this.buildMonthData()
        this.$emit('dateChange', this.date)
      }
      if (target === 'next') {
        this.date = new Date(this.date.getFullYear(), this.date.getMonth() + 1)
        this.buildMonthData()
        this.$emit('dateChange', this.date)
      }
      if (target === 'today') {
        this.date = new Date()
        this.buildMonthData()
        this.$emit('dateChange', this.date)
      }
    },
    eventClass(event, day) {
      return [
        'mdb-event text-white small px-1',
        event.color ? 'bg-' + event.color : 'bg-info',
        event.start.toDateString() === day.date.toDateString() && event.start.toDateString() === event.end.toDateString() ? 'mdb-event-single' :
          event.start < day.date ? 
            new Date(event.end.getFullYear(), event.end.getMonth(), event.end.getDate(), 0, 0, 0) > new Date(day.date.getFullYear(), day.date.getMonth(), day.date.getDate(), 23, 59, 59) ? 'mdb-event-long' : 'mdb-event-end' :
          'mdb-event-start'
      ]
    },
    showEventInfo(event) {
      this.$emit('showEventInfo', event)
    },
    changeView(view) {
      this.$emit('changeView', view)
    },
  },
  watch: {
    defaultDate(newVal) {
      this.date = newVal
      this.buildMonthData()
    }
  },
  filters: {
    shorten: function(value) {
      if (!value) return '';
      value = value.toString();
      return value.slice(0,3) + '...';
    }
  }
}

export default mdbMonthView;
export { mdbMonthView as mdbMonthView };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mdb-month-view {
  width: 100%;
  height: 100%;
  margin-bottom: 50px;
}
.mdb-month-view table {
  table-layout: fixed;
  width: 100%;
}
.mdb-month-view table th, .mdb-month-view table td {
  border: 1px solid #ddd;
}
.mdb-month-view table th {
  text-align: center;
  height: 30px;
  font-weight: bold;
}
.mdb-month-view table td {
  height: 12vh;
  padding-top: 25px;
  vertical-align: top;
  position: relative;
  cursor: pointer;
}
.mdb-month-view table td:hover {
  background-color: rgba(69, 82, 110, 0.05) !important;
}
.mdb-day-field {
  position: absolute;
  right: 8px;
  top: 5px;
}
.mdb-event {
  cursor: pointer;
  font-weight: bold;
}
.mdb-event:hover {
  opacity: 0.7;
}
.mdb-event-single {
  margin: 1px 2px;
}
.mdb-event-start {
  margin: 1px 0;
  margin-left: 2px;
  margin-right: -2px;
}
.mdb-event-long {
  margin: 1px 0;
  margin-left: -2px;
  margin-right: -2px;
  text-indent: -9999px; 
}
.mdb-event-end {
  margin: 1px 0;
  margin-left: -2px;
  margin-right: 2px;
  text-indent: -9999px; 
}
.tooltip {
  font-size: .75rem;
}
</style>
